import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchScopeData = createAsyncThunk("api/scope", async () => {
  const response = await fetch(`${FULL_API_BASE_URL}/get-list-of-scopes`);
  const data = await response.json();
  return data;
});

const ScopeSlice = createSlice({
  name: "scope",
  initialState: {
    scopeData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchScopeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchScopeData.fulfilled, (state, action) => {
        state.loading = false;
        state.scopeData = action.payload;
      })
      .addCase(fetchScopeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default ScopeSlice.reducer;
